/*
  Lightbox van de productgalerij (snippets/product-media-modal.liquid).
  De media staan naast elkaar in een strook met scroll-snap: swipen op touch,
  pijlknoppen en pijltjestoetsen op desktop. De teller en de knoppen volgen
  de scrollpositie.
*/
if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.track = this.querySelector('[role="document"]');
        this.prevButton = this.querySelector('[data-lightbox-prev]');
        this.nextButton = this.querySelector('[data-lightbox-next]');
        this.counter = this.querySelector('[data-lightbox-current]');

        [
          [this.prevButton, -1],
          [this.nextButton, 1],
        ].forEach(([button, step]) => {
          if (!button) return;
          /* ModalDialog sluit de lightbox bij elke muisklik; de knoppen niet. */
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.goTo(this.currentIndex() + step);
          });
        });

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.currentIndex() + 1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.currentIndex() - 1);
          }
        });

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateState());
        });
      }

      get slides() {
        return Array.from(this.track.children);
      }

      currentIndex() {
        return Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
      }

      goTo(index, instant = false) {
        const last = this.slides.length - 1;
        const target = Math.min(Math.max(index, 0), last);
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: instant ? 'instant' : 'smooth' });
      }

      updateState() {
        const index = this.currentIndex();
        const slides = this.slides;
        slides.forEach((slide, i) => slide.classList.toggle('active', i === index));
        if (this.counter) this.counter.textContent = index + 1;
        if (this.prevButton) this.prevButton.disabled = index === 0;
        if (this.nextButton) this.nextButton.disabled = index >= slides.length - 1;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const slides = this.slides;
        const index = Math.max(
          0,
          slides.findIndex((slide) => slide.getAttribute('data-media-id') === mediaId)
        );
        this.goTo(index, true);
        this.updateState();

        const activeMedia = slides[index];
        const activeMediaTemplate = activeMedia && activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia &&
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
